import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import Title from '../ResumenHCE/Title';

import { GenericoEvoluciones } from './GenericoEvoluciones';
import { TraerEvolucionesAfiliado } from '../../../../../actions/hce/hceActions';
import { useDispatch } from 'react-redux';
import { HCE_ESTADOS_PROBLEMAS } from '../../../../../utils/constants';

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const CardPasadasError = (props) => {
  const dispatch = useDispatch();
  const { problemasAfiliiado, hce } = props;
  const [openModalDiagnostico, setOpenModalDiagnostico] = useState(false);
  const [tituloModal, setTituloModal] = useState('');
  const [editProblema, setEditProblema] = useState(null);

  return (
    <React.Fragment>
      {openModalDiagnostico && (
        <GenericoEvoluciones
          open={openModalDiagnostico}
          close={() => {
            setOpenModalDiagnostico(false);
          }}
          titulo={tituloModal}
          hce={hce}
          diagnostico={editProblema}
          disabled={props.disabled}
        />
      )}
      <Title>Problemas pasados a error</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Problema</TableCell>
            <TableCell>Estado Problema</TableCell>
            <TableCell>Doctor</TableCell>
            <TableCell>FechaAlta</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(problemasAfiliiado) &&
          problemasAfiliiado.length > 0 ? (
            problemasAfiliiado.map((infoAfiliado) =>
              infoAfiliado.fechaPasadoAError !== null ? (
                <TableRow key={infoAfiliado.id}>
                  <TableCell>
                    <span
                      onClick={() => {
                        setTituloModal('Evoluciones Paciente');
                        setEditProblema(infoAfiliado);
                        setOpenModalDiagnostico(true);
                        dispatch(TraerEvolucionesAfiliado(infoAfiliado.id));
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {infoAfiliado.problema}
                    </span>
                  </TableCell>
                  <TableCell>
                    {Object.keys(HCE_ESTADOS_PROBLEMAS)
                      .find(
                        (key) =>
                          HCE_ESTADOS_PROBLEMAS[key] ===
                          infoAfiliado.idEstadoProblema,
                      )
                      .replace(/_/g, ' ')}
                  </TableCell>
                  <TableCell>{infoAfiliado.descripcionEfector}</TableCell>
                  <TableCell>
                    {new Date(infoAfiliado.fechaAlta).toLocaleString(
                      'es',
                      optionsfecha,
                    )}
                  </TableCell>
                </TableRow>
              ) : null,
            )
          ) : (
            <Typography style={{ fontStyle: 'italic', fontSize: '1.1rem' }}>
              No hay datos
            </Typography>
          )}
        </TableBody>
      </Table>
    </React.Fragment>
  );
};
